/**
 * @generated SignedSource<<f9fc1ab7a589efe8760242e098223fe0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DevelopmentSectionLinkedBranchRef$data = {
  readonly __typename: "Ref";
  readonly associatedPullRequests: {
    readonly totalCount: number;
  };
  readonly id: string;
  readonly name: string;
  readonly repository: {
    readonly defaultBranchRef: {
      readonly associatedPullRequests: {
        readonly totalCount: number;
      };
      readonly id: string;
      readonly name: string;
      readonly target: {
        readonly __typename: string;
        readonly id: string;
        readonly oid: any;
      } | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly nameWithOwner: string;
  };
  readonly target: {
    readonly __typename: string;
    readonly id: string;
    readonly oid: any;
  } | null | undefined;
  readonly " $fragmentType": "DevelopmentSectionLinkedBranchRef";
};
export type DevelopmentSectionLinkedBranchRef$key = {
  readonly " $data"?: DevelopmentSectionLinkedBranchRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"DevelopmentSectionLinkedBranchRef">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "DevelopmentSectionLinkedBranchRef"
};

(node as any).hash = "acb1effb842b527a4ea1f1a76997dff8";

export default node;
